// frontend/src/pages/AboutPage.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Heart, Sparkles } from 'lucide-react';

export {};

const AboutPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#faf8f6] rounded-3xl p-8 shadow-sm border border-romcom-pink/20 mb-8">
      
      {/* Floating visuals */}
      <div className="absolute top-10 left-5 opacity-30 animate-bounce-slow">
        <Heart className="w-6 h-6 text-romcom-red" />
      </div>

      <div className="absolute top-32 right-10 opacity-20 animate-bounce-slower">
        <Sparkles className="w-5 h-5 text-yellow-300" />
      </div>

      <div className="container mx-auto px-4 pt-24 pb-16 max-w-4xl">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
<div className="flex justify-center mb-6">
  <div className="relative">
    <img 
      src="/logo2.jpeg" 
      alt="RomComThis Logo" 
      className="w-24 h-24 object-contain animate-pulse-gentle"
    />
    <Heart 
      className="absolute -top-2 -right-2 w-8 h-8 text-romcom-red fill-current animate-bounce" 
    />
  </div>
</div>

          <h1 className="text-5xl md:text-6xl font-playfair font-bold text-romcom-red mb-4">
            About Us
          </h1>

          <p className="text-xl text-gray-500 max-w-2xl mx-auto leading-relaxed">
            A corner of the internet dedicated entirely to ROMCOMS 💕
          </p>
        </motion.div>

        {/* Mission */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="bg-[#faf8f6] rounded-3xl p-8 shadow-sm border border-romcom-pink/20 mb-8"
        >
          <h2 className="text-3xl font-playfair font-bold text-gray-700 mb-4">
            Our Mission 💖
          </h2>

          <p className="text-gray-600 text-lg leading-relaxed mb-4">
            Everyone has at least one romantic comedy they return to,
            the one you feel like watching when you’re tired, under the weather, 
            or just want something familiar playing in the background.
          </p>

          <p className="text-gray-600 text-lg leading-relaxed mb-4">
            It might not even be the “best” film in the genre, 
            but it’s the one that somehow stuck with you. 
            They occupy a special spot: people love watching them, quoting them, 
            and rewatching them every year, yet they’re rarely discussed as much as other genres.
          </p>

          <p className="text-gray-600 text-lg leading-relaxed">
            We think they deserve more, whether it’s a classic from the 90s or a hidden modern gem or that one comfort watch you quietly keep returning to,
            our hope is that you discover something that warms your heart.
          </p>
        </motion.div>

        {/* Section divider */}
        <div className="flex justify-center my-8">
          <Heart className="w-6 h-6 text-romcom-pink mx-1" />
          <Heart className="w-6 h-6 text-romcom-red mx-1" />
          <Heart className="w-6 h-6 text-romcom-pink mx-1" />
        </div>

        {/* Writer's Note
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 mb-8"
        >
          <h2 className="text-2xl font-playfair font-bold text-gray-800 mb-3">
            Writer’s Note ✨
          </h2>

          <p className="text-gray-600 text-lg leading-relaxed">
            This little corner of the internet started as a love letter to romantic comedies — 
            the ones that make us laugh, cry, and rewatch at 2 AM. 
            Whether it’s a classic from the 90s or a hidden modern gem, 
            our hope is that you discover something that warms your heart.
          </p>

          <p className="text-gray-600 text-lg leading-relaxed mt-2">
            Thanks for stopping by, and happy watching! 💕
          </p>
        </motion.div> */}

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="bg-gradient-to-r from-romcom-pink to-romcom-red rounded-3xl p-10 text-white text-center"
        >
          <Heart className="w-12 h-12 fill-current mx-auto mb-4" />

          <h2 className="text-3xl font-playfair font-bold mb-3">
            Ready to find your next romcom?
          </h2>

          <p className="opacity-90 mb-6 text-lg">
            Browse our collection of romcoms or get a prescription and let us help you find your next favorite movie!
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => navigate('/movies')}
              className="bg-white text-romcom-red px-8 py-3 rounded-full font-semibold hover:bg-white/90 transition-colors"
            >
              Browse Movies
            </button>

            <button
              onClick={() => navigate('/prescriptor')}
              className="bg-white text-romcom-red px-8 py-3 rounded-full font-semibold hover:bg-white/90 transition-colors flex items-center gap-2">
              Get a Prescription! 💊💕
            </button>
          </div>
        </motion.div>

      </div>
    </div>
  );
};

export default AboutPage;